import { getSizedImageUrl } from '../utils/image';
import { getDetailsCount, getNumberOfResultsString } from '../utils/search';

function renderArticleImage(article) {
  if (article.image === null || article.featured_image === null) {
    return '';
  }

  const image = getSizedImageUrl(article.featured_image.url, '100x');

  return `
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>
    <img class="predictive-search-item__image"
      src="${image}"
      alt="${article.featured_image.alt}"
    />
  `;
}

function renderItemImageSection(article) {
  if (article.image === null || article.image === undefined) {
    return ' ';
  }

  return `
    <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>
      ${renderArticleImage(article)}
    </div>`;
}

export default (article, index, resultsCount) => `
    <li id="search-result-${index}" class="predictive-search-item" role="option" data-search-result>
      <a class="predictive-search-item__link" href="${article.url}" tabindex="-1">
        ${renderItemImageSection(article)}
        <div class="predictive-search__column predictive-search__column--content ${
          getDetailsCount() ? '' : 'predictive-search__column--center'
        }">
          <span class="predictive-search-item__title">
            <span class="predictive-search-item__title-text">${article.title}</span>
          </span>
          <span class="vh">, </span>
          <span class="vh">${getNumberOfResultsString(index + 1, resultsCount)}</span>
        </div>
      </a>
    </li>
  `;
